import React from "react";

const DeliveryTypeSection = ({ deliveryType, setDeliveryType, setShowInfoModal }) => {
    return (
        <div className="delivery-type-box">
            <h4>Choose Delivery Type</h4>
            <div className="radiowrap">
                <label>
                    <input
                        type="radio"
                        name="deliveryType"
                        value="instant"
                        checked={deliveryType === "instant"}
                        onChange={() => {
                            setDeliveryType("instant");
                            setShowInfoModal(true);
                        }}
                    />
                    Instant Delivery
                </label>
                <label>
                    <input
                        type="radio"
                        name="deliveryType"
                        value="schedule"
                        checked={deliveryType === "schedule"}
                        onChange={() => {
                            setShowInfoModal(false);
                            setDeliveryType("schedule")
                        }}
                    />
                    Scheduled Delivery
                </label>
            </div>
        </div>
    );
};

export default DeliveryTypeSection;
